import Vue from 'vue'
import Router from 'vue-router'
import Intro from '@/components/Intro'
import ZipcodeChart from '@/components/ZipcodeChart'
import BassFishing from '@/blog/BassFishing'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '',
      component: Intro
    },
    {
      path: '/lunar-fishing-calendar/:zipcode',
      component: ZipcodeChart
    },
    {
      path: '/lunar-fishing-calendar',
      component: ZipcodeChart
    },
    {
      path: '/largemouth-bass-fishing',
      component: BassFishing
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js